export const gradients = {
  premium: `conic-gradient(from 9.87deg at 55.8% 120.83%,
    #d78721 -105.59deg,
    #fec201 16.52deg,
    #f2b906 40.97deg,
    #d78721 254.41deg,
    #fec201 376.52deg)`,
};
